import styled from "styled-components";

export const HeaderNavbarMobileWrapperDefaultBox = styled.div`
    position: sticky;
    top: 0;
    z-index: 105;
    background-color: ${props => props.theme.colors.backgroundDark};
    color: ${props => props.theme.colors.text};
    padding-top: env(safe-area-inset-top);  //if you change this CSS value please also update  AppleOnDemandRegulationStripeGameStep in  comp.el.style['top'] = 'env(safe-area-inset-top)'; it was the only fix right now for BUG 1972433  , to duplicate this code for NYX AOD path

`;
